<template>
  <vs-row>
    <vs-col vs-w="9"  vs-sm="12"  class="p-2">
      <UserInfo :clientDetails="clientDetails" />
    </vs-col>
    <vs-col vs-lg="3" vs-sm="12" class="p-2">
      <vs-card class="content_mb_0 mb-0  h-full">
        <div class="flex flex-wrap justify-between items-center mb-2">
          <h4>Attach Tag</h4>
        </div>
        <v-select
          append-to-body
          class="w-full"
          label="name"
          taggable
          :create-option="
            (option) => ({ id: option, label: option, name: option })
          "
          :options="tagModuleWise"
          v-model="tagSelected"
          @input="checkingTagChanges(teacher_id)"
          :clearable="false"
          data-vv-name="tag_list"
          name="tag_list"
          multiple
          placeholder="Type and press enter to create a tag and then attach it."
        >
        </v-select>

      </vs-card>
    </vs-col>
    <vs-col vs-lg="6" vs-sm="12" class="p-2">
      <vs-card class="content_mb_0 mb-0 h-full">
        <div class="flex flex-wrap justify-between items-center mb-4">
          <h4>Personal Bio</h4>
        </div>
        <div>
          <vs-tabs class="one_line_tab_label">
            <vs-tab label="Personal Bio">
              <PersonalBio :clientDetails="clientDetails" />
            </vs-tab>
            <vs-tab label="Education">
                <Education  @setAfterUpdate="setAfterUpdate" :educationProps="clientDetails.education" :clientDetails="clientDetails" />
            </vs-tab>
            <vs-tab label="Language">
              <Language @setAfterUpdate="setAfterUpdate" :languageProps="clientDetails.language" :clientDetails="clientDetails" />
            </vs-tab>
            <vs-tab label="Award">
              <Award @setAfterUpdate="setAfterUpdate"  :awardProps="clientDetails.award" :clientDetails="clientDetails" />
            </vs-tab>
            <vs-tab label="Additional Information">
              <AdditionalInfoComponent  :clientDetails="clientDetails" />
            </vs-tab>
          </vs-tabs>
        </div>
      </vs-card>
    </vs-col>
    <vs-col vs-lg="6" vs-sm="12" class="p-2">
      <vs-card class="content_mb_0 mb-0 h-full contact_info_card">
        <div class="flex flex-wrap justify-between items-center mb-4">
          <h4>Contact Information</h4>
        </div>
        <div>
          <vs-tabs>
            <vs-tab label="Email">
              <Email :email="email" />
            </vs-tab>
            <vs-tab label="Phone">
              <Phone
                :clientDetails="clientDetails"
                :checkEditPermission="checkEditPermission"
              />
            </vs-tab>
            <vs-tab label="Address">
              <Address
                :clientDetails="clientDetails"
                :checkEditPermission="checkEditPermission"
              />
            </vs-tab>
          </vs-tabs>
        </div>
      </vs-card>
    </vs-col>
    <!-- <vs-col vs-w="12" class="p-2">
            <vs-card>
                <div class="flex flex-wrap justify-between items-center mb-4">
                    <h4>Additional Information</h4>
                </div>
                <vs-row>
                    <vs-col vs-lg="6" vs-sm="12" class="p-1">
                        <vs-row>
                            <vs-col vs-lg="4" vs-sm="12" class="p-1">
                                <p>About yourself</p>
                            </vs-col>
                            <vs-col vs-lg="8" vs-sm="12" class="p-1">
                                <p :class="[showMore ? 'one_line_truncate' : '']">Lorem ipsum dolor sit amet, consectetur adipiscing elit nsectetur adipiscing elit nsectetur adipiscing elit</p>
                                <a style="white-space: nowrap; cursor: pointer;" class="inline-block" @click="showMore = !showMore">
                                    <span v-if="showMore">Read More</span>
                                    <span v-else>Show Less</span>
                                </a>
                            </vs-col>
                            <vs-col vs-lg="4" vs-sm="12" class="p-1">
                                <p>Short intro</p>
                            </vs-col>
                            <vs-col vs-lg="8" vs-sm="12" class="p-1">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </vs-col>
                            <vs-col vs-lg="4" vs-sm="12" class="p-1">
                                <p>Education</p>
                            </vs-col>
                            <vs-col vs-lg="8" vs-sm="12" class="p-1">
                                <p>Graduation</p>
                            </vs-col>
                            <vs-col vs-lg="4" vs-sm="12" class="p-1">
                                <p>Joining Date</p>
                            </vs-col>
                            <vs-col vs-lg="8" vs-sm="12" class="p-1">
                                <p>10/03/2021</p>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col vs-lg="6" vs-sm="12" class="p-1">
                        <vs-row>
                            <vs-col vs-lg="4" vs-sm="12" class="p-1">
                                <p>Area of Interest</p>
                            </vs-col>
                            <vs-col vs-lg="8" vs-sm="12" class="p-1">
                                <p>Math</p>
                            </vs-col>
                            <vs-col vs-lg="4" vs-sm="12" class="p-1">
                                <p>Open for night shift</p>
                            </vs-col>
                            <vs-col vs-lg="8" vs-sm="12" class="p-1">
                                <p>Yes</p>
                            </vs-col>
                            <vs-col vs-lg="4" vs-sm="12" class="p-1">
                                <p>Picture on the wall</p>
                            </vs-col>
                            <vs-col vs-lg="8" vs-sm="12" class="p-1">
                                <p>Yes</p>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>
            </vs-card>
        </vs-col> -->
  </vs-row>
</template>

<script>
import vSelect from 'vue-select'

import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { Tag } from '@/mixins/tag/tag'

import UserInfo from '@/views/pages/v1/StudentProfile/components/account/user_info.vue'
import AdditionalInfoComponent from '@/views/pages/v1/StudentProfile/components/personal_bio/additional_info'
import Education from '@/views/pages/v1/StudentProfile/components/personal_bio/education.vue'

import PersonalBio from '@/views/pages/v1/StudentProfile/components/profile/personal_bio.vue'
import Email from '@/views/pages/v1/StudentProfile/components/contact_information/email.vue'
import Phone from '@/views/pages/v1/StudentProfile/components/contact_information/phone.vue'
import Address from '@/views/pages/v1/StudentProfile/components/contact_information/address.vue'
import Language from '@/views/pages/v1/StudentProfile/components/personal_bio/language.vue'
import Award from '@/views/pages/v1/StudentProfile/components/personal_bio/award.vue'


export default {
  watch: {
    tagSelected () {
      this.filterTagList(this.platform_module_id)
    }
  },
  data () {
    return {
      platform_module_id:4,
      showMore: true,
      email: null,
      client_id:this.$route.params.client_id
    }
  },
  props: {
    clientDetails: {
      default: null
    }
  },
  components: {
    vSelect,
    UserInfo,
    PersonalBio,
    Email,
    Phone,
    Address,
    AdditionalInfoComponent,
    Education,
    Language,
    Award
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === '1') {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Students')
    }
  },
  mixins: [PermissionMiddleware, Tag],
  mounted () {

    this.email = this.clientDetails.basic_details.email
    this.fetchTag(this.platform_module_id, this.clientDetails.tags)
  },
  methods: {
    setAfterUpdate (data) {
      this.$emit('setAfterUpdate', data)
    },
    removeTag (index) {
      this.tagSelected = this.tagSelected.filter((ele) => ele.id !== index)
    }
  }
}
</script>
